import { InjectionToken } from '@angular/core';

export type TranslationDomainKey = 'ACCOUNT_MANAGEMENT.IDENTITY'
  | 'ACCOUNT_MANAGEMENT.SECURITY'
  | 'ACCOUNT_MANAGEMENT.MFA'
  | 'AUTHENTICATION.LOGIN'
  | 'AUTHENTICATION.TOTP'
  | 'AUTHENTICATION.REAUTHENTICATE'
  | 'AUTHORIZATION.OAUTH_CLIENT'
  | 'AUTHORIZATION.OAUTH_CONSENT'
  | 'RECOVERY.CONFIRM'
  | 'RECOVERY.REQUEST'
  | 'REGISTRATION.REGISTER'
  | 'REGISTRATION.VERIFICATION'


export const TranslationDomain = new InjectionToken<TranslationDomainKey>('TranslationDomainError');
